import { Component, OnInit } from "@angular/core";

import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { AuthService } from "../services/auth.service";

//HttpParams
//import {HttpParams} from "@angular/common/http"

import { default as swal } from "sweetalert2";

declare var $: any;

@Component({
  selector: "app-project",
  templateUrl: "./project.component.html",
  styleUrls: ["./project.component.css"],
})
export class ProjectComponent implements OnInit {

  public href: string = "";
  public add_project = false;
  public list_project = false;
  public edit_project = false;
  
  project_id;

  projectForm;
  submitted;
  projectList;

  project_name;


  constructor(
    private fb: FormBuilder,
    private router: Router,
    public authService: AuthService,
    private route: ActivatedRoute
  ) {   

    this.projectList = [];
    this.add_project = false;
  }

  ngOnInit() {

    this.project_id = this.route.snapshot.paramMap.get('id');  

    this.href = this.router.url;
    console.log(this.router.url);

    if(this.project_id){
      
      this.add_project = true;
      this.list_project = false;
      
      this.authService.getProjects({
        id : this.project_id
      }).subscribe((res:any) =>{
        if(!res.error){
            let data =  res.data;
            this.project_name = data.name;
            this.edit_project = true;
        }
      });

    }else if (this.href == "/project/add") {
      this.add_project = true;
      this.list_project = false;
    } else {
      this.add_project = false;
      this.list_project = true;
      this.getProjects();
    }

    this.submitted = false;
    this.projectForm = this.fb.group({
      name: this.fb.control("", Validators.required),
    });
  }

  addProject() {
    let project_name = this.project_name;

    this.authService
      //.addProject(this.projectForm.value)
      .addProject({name : project_name})
      .subscribe((data: any) => {
        if (data.error) {
          swal("OOPs!", data.message, "error");
        } else {
          swal("Success", data.message, "success");
          this.router.navigate(['./project']);
          this.getProjects();

          setTimeout(function () {
            closeDialog("addProjectModal");
          }, 1000);

          // close the dialog and call the api of fetch projects here
        }
      });
  }
  editProject(){  
    let project_id = this.project_id;
    let name = this.project_name;
    let req_obj = {
      project_id,
      name 
    }

    this.authService
      //.addProject(this.projectForm.value)
      .addProject(req_obj)
      .subscribe((data: any) => {
        if (data.error) {
          swal("OOPs!", data.message, "error");
        } else {
          swal("Success", data.message, "success");
          this.router.navigate(['./project']);
          this.getProjects();

          setTimeout(function () {
            closeDialog("addProjectModal");
          }, 1000);

          // close the dialog and call the api of fetch projects here
        }
      });
    return;
  }
  getProjects(args = {}) {
    
    this.authService.getProjects(args).subscribe((data: any) => {
      if (data.error) {
        swal("OOPs!", data.message, "error");
      } else {
        this.projectList = data.data;
        //swal('Success', data.message, 'success');
      }
    });
  }
}

function closeDialog(selectr) {
  $("#" + selectr).modal("hide");
}



// WEBPACK FOOTER //
// /home/lynkit/Downloads/staging-boltseal/boltseal/newsletter-client/src/app/project/project.component.ts